import React from 'react';
import SearchEmojis from './SearchEmojis';
import Footer from './Footer';

function App() {
  return (
    <main>
      <SearchEmojis />
      <Footer />
    </main>
  );
}

export default App;
